export default __webpack_public_path__ + "static/bg-applicant-details-5515d22cb16ee1f4bccecb0459715dfd.png";